import React from 'react';
import { ListContent, ListIcon, SemanticICONS } from 'semantic-ui-react';

import Popup from '@src/components/common/Popup';

import { SidebarContext } from '../../../../../../../../components/nav/Sidebar';
import { SidebarListItemContent } from './style';

export type ItemContentProps = {
  content?: string;
  icon: SemanticICONS;
  circularIcon?: boolean;
  additionalIcon?: any;
  active: boolean;
  popupContent?: any;
  disabled?: boolean;
};

function ItemContent({
  active,
  disabled,
  additionalIcon,
  icon,
  circularIcon,
  content,
  popupContent,
}: ItemContentProps) {
  return (
    <SidebarContext.Consumer>
      {({ sidebarCollapsed }) => {
        const C = (
          <SidebarListItemContent active={active && !disabled} disabled={!!disabled}>
            <span>
              {additionalIcon === undefined ? (
                <ListIcon
                  name={icon}
                  circular={circularIcon}
                  className={sidebarCollapsed ? 'collapsed' : ''}
                />
              ) : (
                <i className={`icons ${sidebarCollapsed ? 'collapsed' : ''}`}>
                  <i className={`icon ${icon}`} />
                  {additionalIcon}
                </i>
              )}
            </span>
            {!sidebarCollapsed ? (
              <ListContent style={{ paddingLeft: '8px' }}>{content}</ListContent>
            ) : null}
          </SidebarListItemContent>
        );
        if (!popupContent) {
          return C;
        }
        return <Popup trigger={C} content={popupContent} position="right center" basic={false} />;
      }}
    </SidebarContext.Consumer>
  );
}

export default ItemContent;
